// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"fb4c4a00","55":"179710c2","93":"49e72870","154":"a0f833f3","238":"ecdfc138","538":"4e3f85ff","615":"25889462","711":"4991c661","783":"709e9657","788":"6043938a","827":"d47a079e","882":"ef28452e"}[chunkId] + ".chunk.js";
};